import React from 'react';
import ServiceTech from '../../component/servicetech'
import consutancyheader from '../../assets/consutancyheader.jpg';
import consutancykey1 from '../../assets/consultancy1.jpg';
import consutancykey2 from '../../assets/consulting_2.jpg';
import consutancykey3 from '../../assets/consulting_3.jpg';
const Softwareconsultancy = () => {
  const data =  {
    "headerimg":consutancyheader,
    "key1img":consutancykey1,
    "key2img":consutancykey2,
    "key3img":consutancykey3,
    "maintitle":"Expert guidance today ensures your business thrives tomorrow",
    "mainsub":"Partner in Strategic Growth and Success",

    "title":"Consultancy",
    "subtext":"Our consultancy services provide strategic expertise that helps businesses overcome complex challenges and drive growth. We offer tailored solutions across operations, technology, and digital transformation, ensuring your business stays competitive in a dynamic market. From risk management to process optimization, we partner with you to deliver sustainable and measurable results.",
   "choose1": "We provide expert consulting that enables organizations to redefine their operations and enhance performance. Our personalized approach ensures that your specific business needs are addressed effectively, whether in process improvement, digital transformation, or strategic planning. We work closely with you to develop solutions that drive growth and foster long-term success.",

    "choose2": "We offer personalized advice and customized solutions designed to ensure your business objectives are met with precision. Whether focusing on digital transformation, operations, technology, or overall strategy, our dedicated team works collaboratively with you to develop innovative approaches that drive success and deliver measurable results for your organization.",

    "choose3": "Our consultants are committed to ensuring that your business remains compliant with complex regulatory standards while mitigating operational risks. By implementing effective strategies, we secure long-term growth and help you avoid costly penalties. Our proactive approach empowers your organization to navigate challenges and thrive in an increasingly regulated landscape.",
     "key1":"Strategic Insights",
    "key2":"Tailored Solutions",
    "key3":"Expert Guidance",
    "key4":"Risk Management",
    "key5":"Change Management",
    "text1":"Our consultancy services provide expert advice, helping businesses align their technology and operations with long-term goals, ensuring they stay competitive in the market.",
    "text2":"We understand that every business is unique. Our consultants deliver customized solutions that address specific challenges and opportunities within your industry.",
    "text3":"With deep industry expertise, our consultancy services guide businesses through complex challenges, from digital transformation to operational efficiency improvements",
    "text4":"Through in-depth analysis, we help businesses identify and mitigate risks across all operations, ensuring sustainable growth and compliance",
    "text5":"We assist in navigating change with structured strategies, ensuring that transformations—whether technological or operational—are smooth and well-integrated into your business..",
    "text6":"With our expertise in Consultancy, organizations can rethink, re-engineer, and optimize their strategies for enhanced performance and sustainable growth."




}

  return (

 

  <>
    <ServiceTech values={data} />
  </>

    
 
)
};

export default Softwareconsultancy;
